<ng-container *transloco="let t">
  <div class="pt-32-15 pb-300-100">

    @if(!isMobile) {
      <div class="row">
        <div class="col-md-8 d-flex flex-column gap-3">
          <ng-template [ngTemplateOutlet]="seasonProgress"></ng-template>
          <ng-template [ngTemplateOutlet]="nextEvent"></ng-template>
          <ng-template [ngTemplateOutlet]="upcomingEventsTemplate"></ng-template>
          <ng-template [ngTemplateOutlet]="aboutLeague"></ng-template>
          <ng-template [ngTemplateOutlet]="leagueRules"></ng-template>

        </div>
        <div class="col-md-4 d-flex flex-column gap-3">
          <ng-template [ngTemplateOutlet]="organizers"></ng-template>
        </div>
      </div>
    } @else {
      <div class="d-flex flex-column gap-3">
        <ng-template [ngTemplateOutlet]="seasonProgress"></ng-template>
        <ng-template [ngTemplateOutlet]="nextEvent"></ng-template>
        <ng-template [ngTemplateOutlet]="upcomingEventsTemplate"></ng-template>
        <ng-template [ngTemplateOutlet]="aboutLeague"></ng-template>
        <ng-template [ngTemplateOutlet]="leagueRules"></ng-template>
        <ng-template [ngTemplateOutlet]="organizers"></ng-template>
      </div>
    }

    <ng-template #seasonProgress>
      <div class="league-section">
        <div class="d-flex flex-column gap-2 mb-3">
          <p class="fw-500 fs-14 color-slate-600"> {{ t('league.overview.season.progress') | uppercase}} </p>
          @if (league?.status === LeagueStatus.FINISHED) {
            <span class="tag cyan"> {{ t('app.common.finished')}}</span>
          } @else {
            <div class="d-flex justify-content-between">
              @if (league?.roundsEnabled) {
                <div class="tag cyan gap-2">
                  <p>{{ leagueEvents | leagueNextRound:'ratio' }}</p>
                  <i class="bi bi-circle-fill" style="font-size: 6px;"></i>
                  @if ((leagueEvents | leagueNextRound:'index') <= 1) {
                    <p>{{ t('league.progress.soon') }}</p>
                  } @else {
                    <p>{{ t('league.progress.in.progress') }}</p>
                  }
                </div>
              }
            @else {
              <div></div>
            }

              <div *ngIf="!isMobile" class="d-flex align-items-end">
                <p class="fw-500 fs-14 color-slate-600">{{
                  t('league.events.completed',
                  { completed: finishedNumberOfEvents,
                    totalEvents: totalNumberOfEvents
                  }) | uppercase
                  }}
                </p>
              </div>
            </div>
          }


        </div>
        <div class="progress-container">
          @let percentage = totalNumberOfEvents > 0 ? (finishedNumberOfEvents / totalNumberOfEvents) * 100 : 0;
          <div class="progress-bar-bg">
            <div class="progress-bar-fill" [style.width.%]="percentage"></div>
          </div>
        </div>
        <div *ngIf="isMobile" class="d-flex justify-content-end align-items-end mt-2">
          <p class="fw-500 fs-14 color-slate-600">{{ t('league.events.completed',
                  { completed: finishedNumberOfEvents,
                          totalEvents: totalNumberOfEvents}) | uppercase}}</p>
        </div>
      </div>

    </ng-template>

    <ng-template #nextEvent>
      <div class="d-flex flex-column gap-2">
        <p class="title"> {{ t('league.overview.next.event')}} </p>
        <div class="league-section no-padding mb-3 mb-md-0">
          @if (leagueEvents?.nextRound) {
                <div class="col">
                  <app-event-grid-item [eventItem]="leagueEvents!.nextRound!" [layout]="isMobile ? CalendarViewType.GRID : CalendarViewType.LIST"
                                       (onRightButtonClickCallback)="goToEventDetailsPage(leagueEvents!.nextRound!)"
                                       [showActionButton]="navigateEventIds.has(leagueEvents!.nextRound!.id!)"
                                       [isLeagueEvent]="true" [hideShadow]="true"
                                       [hasIcons]="false" [hasBorder]="false" [hasFavorite]="false"
                                       [hasShare]="false"
                                       [smallImage]="true"
                                       [showRegistrationCloses]="true"
                                       [languages]="languages"/>

                </div>
          }
        </div>
      </div>
    </ng-template>

    <ng-template #upcomingEventsTemplate>
      <div class="d-flex flex-column gap-2">
        <div class="d-flex justify-content-between align-items-center">
          <p class="title"> {{ t('app.landing.upcoming.events')}} </p>
          @if (!isMobile) {
            <app-button-alt (onClickCallback)="goToEvents()" [buttonColor]="'transparent'" [textColor]="'var(--teal-500)'" [buttonHeight]="'35px'"
                            [text]="t('league.view.all.events')" [borderColor]="'transparent'" [textTransform]="'none'"
                            [trailingIcon]="'assets/icons/icons-alt/chevron-right.svg'" [trailingIconSize]="'16px'"
            ></app-button-alt>
          }
        </div>
        @for (event of upcomingEvents; track event.id; let i = $index;) {
        <div class="league-section color-slate-600 fw-400"
            [class.clickable]="navigateEventIds.has(event.id!)"
            (click)="navigateEventIds.has(event.id!) && goToEventDetailsPage(event)">
          <div class="d-flex gap-3">
            @if (league?.roundsEnabled) {
              <div class="d-flex align-items-center justify-content-center">
                <p class="league-section neutral fw-semibold">{{ event.round }}</p>
              </div>
            }
          <div class="d-flex flex-column gap-1 flex-grow-1 align-items-start justify-content-center">
            <p class="fw-600 color-slate-800">
            <app-language-output [hrLabel]="event?.name" [srLabel]="event?.nameSr"
                                 [enLabel]="event?.nameEng" [itLabel]="event?.nameIta"
                                 [bsLabel]="event?.nameBs" [siLabel]="event?.nameSlo"
                                 [defaultLanguage]="event?.defaultLanguage" [languages]="languages"/>
          </p>
          <div class="d-flex align-items-center">
            <app-event-date-display [start]="event?.start" [end]="event?.end" class="grey-600"/>
            <i class="bi bi-dot"></i>
            <app-location-display [city]="event?.city" [countryId]="event?.country" [cssClass]="'grey-600'" [showIcon]="false"/>
          </div>
          <app-event-lengths-display [event]="event" [showIcon]="false"/>
        </div>

        @if (navigateEventIds.has(event.id!)) {
        <div class="d-flex align-items-center align-items-md-end justify-content-center" (click)="goToEventDetailsPage(event)">
          <i class="bi bi-chevron-right color-teal-500 d-md-none"></i>
          <p class="fw-500 color-teal-500 cursor-pointer d-none d-md-block">{{ t('app.common.view.event') }}</p>
        </div>
        }
        </div>

        <div>
         @if (templateStatusBanner[event.leagueTemplateStatus!]; as banner) {
            <ng-template [ngTemplateOutlet]="eventBanner" [ngTemplateOutletContext]="banner"/>
          }
        </div>
      </div>
        }
        @if (isMobile) {
          <div class="d-flex justify-content-center">
            <app-button-alt (onClickCallback)="goToEvents()" [buttonColor]="'transparent'" [textColor]="'var(--teal-500)'" [buttonHeight]="'35px'"
                            [text]="t('league.view.all.events')" [borderColor]="'transparent'" [textTransform]="'none'"
                            [trailingIcon]="'assets/icons/icons-alt/chevron-right.svg'" [trailingIconSize]="'16px'"
            ></app-button-alt>
          </div>
        }
      </div>
    </ng-template>

    <ng-template #aboutLeague>
      <div class="d-flex flex-column gap-2">
        <p class="title"> {{ t('league.overview.about.league') }} </p>
        <div class="league-section">
          <div class="expandable-text">
            <div class="content color-slate-600" [class.collapsed]="!aboutExpanded" [style.--collapsed-lines]="5" [style.text-align]="'justify'">
              <app-language-output [multiLangValue]="league?.description"
                                   [languages]="languages" [showAsInnerHtml]="true"
                                   [defaultLabel]="t('race.details.empty')"
              />
            </div>

            <div class="d-flex justify-content-center pt-3">
              <app-button-alt (onClickCallback)="toggleAbout()" [buttonColor]="'transparent'" [textColor]="'var(--teal-500)'" [buttonHeight]="'35px'"
                              [text]="t(aboutExpanded ? 'app.common.show.less' : 'race.details.read.more')" [borderColor]="'transparent'"
                              [trailingIcon]="(aboutExpanded ? 'assets/icons/icons-alt/chevron_up_alt.svg' : 'assets/icons/icons-alt/chevron_down_alt.svg')"
                              [trailingIconSize]="'16px'" [textTransform]="'none'" [fontSize]="'14px'"
              ></app-button-alt>
            </div>

          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #leagueRules>
      <div class="d-flex flex-column">
        <div class="league-section rounded-bottom-0">
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center gap-2 flex-grow-1">
              <img src="assets/icons/icons-alt/gavel.svg" alt="Rules" class="card-body__icon p-1 ps-0"/>
              <p class="fw-500">{{ t('league.details.rules') }}</p>
            </div>
            <div class="d-flex justify-content-end">
              <p (click)="goToInfo()" class="fs-14 fw-500 color-teal-500 cursor-pointer">{{ t('race.details.read.more') }}</p>
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #organizers>
      <div class="league-section d-flex flex-column gap-2">
        <p class="fs-14 fw-400 color-slate-600"> {{ t('league.overview.organized.by') | uppercase }} </p>
        <p> {{ league?.organiser?.name }} </p>
        @if (league?.officialWebsite) {
        <div (click)="goToOfficialLeaguePage()" class="d-flex justify-items-start align-items-center gap-2 cursor-pointer">
          <p class="color-teal-500 fs-14"> {{ t('league.overview.official.league.page') }} </p>
          <img src="assets/icons/icons-alt/external-link.svg" alt="Link" class="p-1 ps-0" width="20px" height="20px"/>
        </div>
        }
      </div>
    </ng-template>

    <ng-template #eventBanner let-icon="icon" let-color="color" let-key="key">
      <div class="divider-horizontal width-100 mt-3 mb-2"></div>
      <div class="d-flex align-items-center gap-1 {{color}}">
        <img src="assets/icons/icons-alt/{{icon}}.svg" alt="Warning" [width]="18" [height]="18"/>
        <p class="fs-12 ps-1 fs-500">{{ t(key) | uppercase }}</p>
      </div>
    </ng-template>

<!--    todo league join-->
<!--    <div class="league-section mb-3">-->
<!--      <div class="d-flex fw-500 fs-20 mb-3 ps-1">-->
<!--        <div style="width: 5px; height: auto; background-color: #b05963; border-radius: 8px;" class="me-3"></div>-->
<!--        <p>{{ t("league.tab.overview.join") }}</p>-->
<!--      </div>-->
<!--      <div class="league-section teal mb-3">-->
<!--        <p class="grey-600">-->
<!--          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque ullamcorper ornare tempor. Praesent ultricies felis ut iaculis fermentum. Nunc eget tellus in mauris finibus placerat in ac justo.-->
<!--        </p>-->
<!--      </div>-->
<!--      <app-button-alt [buttonColor]="'var(&#45;&#45;teal-500)'" [textColor]="'white'" [buttonHeight]="'35px'"-->
<!--                      [text]="t('league.create.team') | uppercase" [borderColor]="'var(&#45;&#45;teal-500)'"-->
<!--      ></app-button-alt>-->
<!--    </div>-->
  </div>
</ng-container>
